export default __webpack_public_path__ + "static/media/serverpoint.24c3243f.svg";